import { render } from "./MatchmakerResults.vue?vue&type=template&id=60d11d00&scoped=true"
import script from "./MatchmakerResults.vue?vue&type=script&lang=js"
export * from "./MatchmakerResults.vue?vue&type=script&lang=js"

import "./MatchmakerResults.vue?vue&type=style&index=0&id=60d11d00&lang=scss&scoped=true"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptrweb\\release-RPTRWEB-3586\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60d11d00"]])

export default __exports__